import {Injectable} from '@angular/core';

@Injectable()
export class TenantSettingsStore {
    constructor() {}
}
